const BASE_URL = 'account/{accountId}/event/{eventId}/ai-feature';
export const GENERATE_PASSPORT_BACKGROUND = `${BASE_URL}/generate-passport-background`;
export const GET_GENERATE_MEETINGS_IDENTIFIER = `${BASE_URL}/generate-meetings-data/identifier`;
export const GENERATE_MEETINGS_DATA = `${BASE_URL}/generate-meetings-data/?identifier={identifier}`;